// extracted by mini-css-extract-plugin
export default {"fullWidth":"ro-z","image":"so-z","lazyLoadPicture":"to-z","lazyLoadSpinner":"uo-z","lazyLoadSpin":"vo-z","lazyLoadImage":"wo-z","hasStyledAspectRatio":"xo-z"};